import React from "react"
import { componentStyles } from "@mallardbay/lib-react-components"

import { TextMediumBold } from "~components/shared/todo-lib-react-components/text"
import SimpleGrid from "~components/shared/todo-lib-react-components/simple-grid"
import GridItem from "~components/shared/todo-lib-react-components/grid-item"

import FilterCheckbox from "./filter-checkbox"

interface Props {
    readonly label: string
    readonly items: { id: string; name: string }[]
    readonly selectedItems: string[]
    readonly onItemChange: (props: { id: string; value: boolean }) => void
}

export default function CheckboxGridSection({
    label,
    items,
    selectedItems,
    onItemChange,
}: Props) {
    const styles = useStyleProps()
    const gridColumns = { base: 2, sm: 3 }
    const gridProps = { spacing: "0px", columns: gridColumns }

    return (
        <>
            <TextMediumBold style={styles.label}>{label}</TextMediumBold>
            <SimpleGrid {...gridProps}>
                {items.map(({ id, name }) => (
                    <GridItem key={id}>
                        <FilterCheckbox
                            label={name}
                            isChecked={selectedItems.includes(id)}
                            onChange={(value: boolean) =>
                                onItemChange({ id, value })
                            }
                        />
                    </GridItem>
                ))}
            </SimpleGrid>
        </>
    )
}

function useStyleProps() {
    return componentStyles({
        label: {
            paddingTop: "15px",
        },
    })
}
